import React from 'react';
import { Router } from 'react-router-dom';
import { useLayoutEffect, useState } from 'react';
import type { BrowserHistory } from 'history';

type Props = {
  history: BrowserHistory;
  children: React.ReactNode;
};

const CustomRouter = ({ history, children }: Props) => {
  const [location, setLocation] = useState(history.location);

  useLayoutEffect(() => {
    const unlisten = history.listen(({ location }) => {
      setLocation(location);
    });
    return unlisten;
  }, [history]);

  return (
    <Router navigator={history} location={location}>
      {children}
    </Router>
  );
};

export default CustomRouter;
